/**
 * Format address with whatever data it has given
 * @param {object} props required. address, houseNumber, index, city, state, box, country. All in string type
 * @returns string of one line formatted address
 */

export default function(props) {
  let {
    address,
    houseNumber,
    index,
    city,
    state,
    box,
    country
  } = translatePropertyNames(props);

  let houseNumberWithBox = houseNumber ?? "";
  if (box) {
    if (!houseNumberWithBox) {
      houseNumberWithBox += box;
    } else {
      houseNumberWithBox += " / " + box;
    }
  }

  let addressText = [address, houseNumberWithBox, index, city, state, country]
    .filter(Boolean)
    .map(txt => {
      txt = txt.trim();
      if (txt[txt.length - 1] != ",") {
        txt += ",";
      }
      return txt;
    })
    .join(" ");

  if (addressText[addressText.length - 1] == ",") {
    // remove the last comma
    addressText = addressText.slice(0, addressText.length - 1);
  }

  return addressText;
}

/**
 * Handle object when its straight from apollo
 * @param {object} props Address type object
 * @returns new property names for addressFormat to function
 */
function translatePropertyNames(props) {
  if (!props.__typename) return props;

  return {
    address: props.addressText,
    houseNumber: props.addressHouse,
    index: props.addressIndex,
    city: props.addressCity,
    state: props.addressState,
    box: props.addressBox,
    country: props.addressCountry?.name ?? null
  };
}

export const AddressFragment = `
  id
  addressText
  addressHouse
  addressCity
  addressIndex
  addressState
  addressBox
  addressCountryId
  addressCountry @client {
    id
    name
  }
`;
